const fontConfig = { 'font-size': '13px' }

export const node = {
    cursor: 'all-scroll',
    fill: "#2278b5"
}

export const nestedTransactionConfig = {
    fill: '#d7b7ed',
    'fill-opacity': 0.3
}

export const nestedOneofTransactionConfig = {
    fill: '#8cb3f3',
    'fill-opacity': 0.3
}

export const nestedConditionalTransactionConfig = {
    fill: '#ef9898',
    'fill-opacity': 0.3
}

export const nestedLoopTransactionConfig = {
    fill: '#f1c974',
    'fill-opacity': 0.3
}

export const drawingTrackingTransactionConfig = {
    fill: '#780000',
    'fill-opacity': 0.3
}

export const nestedTransactionLabelConfig = {
    fill: '#273e65',//'#32a157', // '#e3d19f',
    ...fontConfig
}

export const disabledNestedTransactionLabelConfig = {
    fill: '#a0b1c7',
    'cursor': 'not-allowed',
    "opacity": 0.6 ,
    "pointer-events": "none",
    ...fontConfig
}

export const endpointRectangleConfig = {
    fill: '#3a5c95',
    stroke: '#3a5c95',
    ...fontConfig
}

export const disabledEndpointRectangleConfig = {
    fill: '#b2c0d8',
    stroke: '#b2c0d8',
    ...fontConfig
}

export const conditionalEventLabelConfig = {
    fill: '#1a668b',
    ...fontConfig
}

export const invokedTransactionConfig = {
    fill: '#f6faaf',
    'fill-opacity': 0.9,
    ...fontConfig
}

export const labelAttributes = {
    'text-anchor': 'middle',
    'fill': '#FFF',
    'cursor': 'pointer',
    'title': 'Click to edit or delete the event',
    ...fontConfig
}


export const endPointLabelAttributes = {
    'text-anchor': 'middle',
    'fill': '#FFF',
    ...fontConfig
}


export const translabelAttributes = {
    ...labelAttributes,
    'text-anchor': 'start',
    'title': 'Click to edit or delete the transaction',
}

export const eventAttributes = {
    'stroke-width': '3px',
    'stroke': '#273e65', //'#4f9c7c',
    'arrow-end': 'classic-wide-long',
    'title': 'Click to edit or delete the event',
    'cursor': 'pointer'
}

export const disabledEventAttributes = {
    'stroke-width': '3px',
    'stroke': '#a0b1c7', 
    'arrow-end': 'classic-wide-long',
    'cursor': 'not-allowed',
    "opacity": 0.6 ,
    "title": "Not applicable. Condition transaction/var is set to false"
}

export const eventAttributes1 = {
    'stroke-width': '3px',
    'stroke': '#ea7b8b', //'#4f9c7c',
    // 'arrow-end': 'classic-wide-long',
    'title': 'Click to edit or delete the event',
    'cursor': 'pointer'
}

export const templatedTransactionConfig = {
    ...nestedTransactionConfig,
    fill: '#3c54f0'
}

export const dragHandler = {

    'title': 'Click to drag the event',
    'fill': '#0000FF',
    'cursor': 'ns-resize',
    "stroke-width": "2px",
    'stroke-opacity': 1.0,
}
export const backRect = {
    'title': 'Click to drag the event',
    // 'fill': '#0000FF',
    'cursor': 'move',
    "stroke-width": "1px",
}
